// extracted by mini-css-extract-plugin
export var speaker = "speaker-module--speaker--312fb";
export var speaker__descName = "speaker-module--speaker__desc-name--aa51c";
export var speaker__descProf = "speaker-module--speaker__desc-prof--be571";
export var speaker__descWrapper = "speaker-module--speaker__desc-wrapper--41e19";
export var speaker__imageBlock = "speaker-module--speaker__image-block--4cd09";
export var speaker__list = "speaker-module--speaker__list--58b9b";
export var speaker__row = "speaker-module--speaker__row--d0501";
export var speaker__title = "speaker-module--speaker__title--60472";